module.exports = __webpack_public_path__ + "img/Apple Store logo.a4dee76e.png";